import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { MsalModule } from '@azure/msal-angular';

import { routes } from './app.routes';
import { AppConfigService } from './core/services/app-config.service';
import { getMsalProviders } from './core/rebarauth/rebar.auth.module';
import { RebarAuthService } from './core/rebarauth/rebar.auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(withEventReplay()),
    provideAppInitializer(() => {
      const configService = inject(AppConfigService);
      return configService.load();
    }),
    provideAppInitializer(() => {
      // Eagerly instantiate RebarAuthService to activate its inProgress$ subscription
      inject(RebarAuthService);
    }),
    importProvidersFrom(MsalModule),
    ...getMsalProviders(),
  ],
};
